export const SET_FILTER = "SET_FILTER";
export const CHANGE_FILTER = "CHANGE_FILTER";